import { GET_REQUEST } from '@helpers/request';
import { API_CONTRACT_UPLOAD_PATH } from '../env';

const structurePaths = {
  documentTypes: API_CONTRACT_UPLOAD_PATH + '/getAllPendingDocumentTypes',
  uploadDocumentHistories:
    API_CONTRACT_UPLOAD_PATH + '/findUploadDocumentHistoryBy',
};
export const getAllPendingDocumentTypesService = () => {
  return GET_REQUEST(structurePaths.documentTypes, {});
};

export const findUploadDocumentHistoryByService = ({
  uploadDocumentTypeCode,
  policyId,
  fileName,
  fromUploadDate,
  toUploadDate,
  page,
  size,
}) => {
  const data = {
    uploadDocumentTypeCode,
    policyId,
    fileName,
    fromUploadDate,
    toUploadDate,
    page,
    size,
  };
  return GET_REQUEST(structurePaths.uploadDocumentHistories, data);
};
